import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, ApiResponse, PaginationType } from "@lib/types/Api";
import { BillingHistory, Wallet, WalletAddress } from "@lib/types/Billing";
import { ScannedTransaction } from "@lib/types/Transaction";

export const apiAddBillingWallet = async (data: Wallet) => {
  return API.post<Wallet>(`/billing-wallet`, data);
};

export const apiDeleteBillingWallet = async (data: Wallet) => {
  return API.delete<null>(`/billing-wallet/${data.id}`);
};

export const apiUpdateBillingWallet = async (data: Wallet) => {
  const { id, ...rest } = data;
  return API.patch<Wallet>(`/billing-wallet/${id}`, rest);
};

export const apiGetBillingWallets = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/billing-wallet` });
  return API.get<PaginationType<Wallet>>(url);
};

export const apiAddMultipleBillingWalletAddress = async (
  data: WalletAddress[],
) => {
  return API.post<WalletAddress[]>(`/billing-wallet-address/bulk`, data);
};

export const apiAddBillingWalletAddress = async (data: WalletAddress) => {
  return API.post<WalletAddress>(`/billing-wallet-address`, data);
};

export const apiDeleteBillingWalletAddress = async (data: WalletAddress) => {
  return API.delete<null>(`/billing-wallet-address/${data.id}`);
};

export const apiUpdateBillingWalletAddress = async (
  data: Partial<WalletAddress>,
) => {
  const { id, ...rest } = data;
  return API.patch<WalletAddress>(`/billing-wallet-address/${id}`, rest);
};

export const apiGetBillingWalletAddress = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/billing-wallet-address` });
  return API.get<PaginationType<WalletAddress>>(url);
};

// #
// ####### billing-scanned-transaction #######
export const apiGetBillingScannedTransaction = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/billing-scanned-transaction` });
  return API.get<PaginationType<ScannedTransaction>>(url);
};
export const apiAddScanWalletAddress = async (id: string) => {
  const url = `/billing-scanned-transaction/scan/wallet-address/${id}`;
  return API.post<ApiResponse>(url);
};

// #
// ####### billing-history #######
export const apiAddBillingHistories = async (
  data: Partial<BillingHistory>[],
) => {
  return API.post<Partial<BillingHistory>[]>(`/billing-history/bulk`, {
    bulk: data,
  });
};

export const apiAddBillingHistory = async (data: Partial<BillingHistory>) => {
  return API.post<Partial<BillingHistory>>(`/billing-history`, data);
};

export const apiDeleteBillingHistory = async (data: BillingHistory) => {
  return API.delete<null>(`/billing-history/${data.id}`);
};

export const apiGetBillingHistories = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/billing-history` });
  return API.get<PaginationType<BillingHistory>>(url);
};
